import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { TestTube } from 'lucide-react';

interface TestIndexingFormProps {
  onTest: (paperId: string) => void;
  isLoading: boolean;
}

export const TestIndexingForm = ({ onTest, isLoading }: TestIndexingFormProps) => {
  const [paperId, setPaperId] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (paperId.trim()) {
      onTest(paperId.trim());
      setPaperId('');
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <TestTube className="h-5 w-5" />
          Test Indexing
        </CardTitle>
        <CardDescription>
          Manually queue a paper for search engine indexing
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="flex gap-2">
          <Input
            placeholder="Enter Paper ID (UUID)"
            value={paperId}
            onChange={(e) => setPaperId(e.target.value)}
            className="flex-1"
          />
          <Button type="submit" disabled={isLoading || !paperId.trim()}>
            {isLoading ? 'Queueing...' : 'Test'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};
